import(/* webpackMode: "eager" */ "/vercel/path0/frontend/app/pricing/page.tsx");
